import {atom} from "recoil";
import {CompanionPlanResponse} from "../../models/companion-plan-response";
import {InquireCompanionFlowResponse} from "../../models/inquire-companion-flow-response";

export interface PlanState {
  companionPlansResponse?: CompanionPlanResponse;
  customerOrderId: number;
  imeiAndCustomerValid?: boolean;
  createWatchOrderResponse: CreateWatchOrderResponse;
  selectedAddressFromForm: CapturedAddress;
  selectedAutoCompleteAddressObject: CapturedAddress;
  selectedAutoCompleteAddress: string;
  maximumWatchSubsExceeded?: boolean;
  inquireCompanionFlowResponse?: InquireCompanionFlowResponse;
  emergencyAddress: CapturedAddress;
  serviceAddress: CapturedAddress;
}

export interface CreateWatchOrderResponse {
  customerOrderId: number;
  capturedAddress: CapturedAddress;
  tmoBillingAccountId: number;
  watchInfo?: WatchInfo;
  pairAccountId?: number;
}

export interface InquireAddressResponse {
  emergencyAddress: CapturedAddress;
  serviceAddress: CapturedAddress;
}

export interface WatchInfo {
  carrierPostData: string;
  eid: string;
  iccid: string;
  displayName: string;
  deviceImei: string;
  deviceMeid: string;
  deviceType: string;
  primaryDeviceIccid: string;
}

export interface CapturedAddress {
  generalParameterList?: any[];
  addrId?: number;
  rowId?: number;
  dataTpId?: number;
  addrTpId?: number;
  addrDesc?: string;
  isActv?: number;
  cdate?: number;
  cuser?: number;
  addrPrflId?: number;
  addressType?: string;
  uniqueAddrId?: string;
  strtName?: string;
  pstlCode?: string;
  stateCode?: string;
  cntryCode?: string;
  strtNum?: string;
  civicNumber?: string;
  locality?: string;
  parameters: Parameter[];
  localCallingAreas?: any[];
  legalAddress?: boolean;
  primaryAddress?: boolean;
  subAddrId?: string;
  updated?: boolean;
  watchAccountIds?: number[];
  tmoBillAccountId?: number;
}

export interface AutoCompleteResponse {
  addressDescription: string;
  addressId: string;
}

interface Parameter {
  value: string;
  shortCode: string;
}

export interface InquireAddressFieldsResponse {
  portabilityOrientationList: OrientationFiels[];
  portabilityPremisesTypeList: PremisesTypeFields[];
  portabilityProvinceList: ProvinceFields[];
  portabilityStreetTypeList: StreetTypeFields[];
}

export interface OrientationFiels {
  portabilityOrientationId: number;
  shrtCode: string;
  isActv: number;
  name: string;
}

export interface PremisesTypeFields {
  portabilityPremisesTpId: number;
  shrtCode: string;
  isActv: number;
  name: string;
}

export interface ProvinceFields {
  portabilityPrvncId: number;
  portabilityPrvncCode: string;
  isActv: number;
  isDflt: number;
  name: string;
}

export interface StreetTypeFields {
  portabilityStreetTpId: number;
  shrtCode: string;
  isActv: number;
  name: string;
}

export const planState = atom<PlanState>({
  key: "planState",
  default: {
    companionPlansResponse: {} as CompanionPlanResponse,
    customerOrderId: 0,
    imeiAndCustomerValid: true,
    createWatchOrderResponse: {} as CreateWatchOrderResponse,
    selectedAddressFromForm: {} as CapturedAddress,
    selectedAutoCompleteAddress: "",
    selectedAutoCompleteAddressObject: {} as CapturedAddress,
    maximumWatchSubsExceeded: false,
    inquireCompanionFlowResponse: {} as InquireCompanionFlowResponse,
    emergencyAddress: {} as CapturedAddress,
    serviceAddress: {} as CapturedAddress,
  },
});
